const data = [
  // [1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43, 44, 53, 54, 59]
  // [60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90]
  {
    id: 1, // nanoid() - programatically generated throu NanoID library
    email: "laurasmith@fakegmail.com", //check for valid email | required for both hunter and talent | Check if user already exists <-> later feature
    password: "1234", //check for valid email | required for both hunter and talent
    userType: "talent", // Radio button? | Required | either "hunter" or "talent"
    firstName: "", // Required for userType = "hunter" sign up
    lastName: "", // Required for userType = "hunter" sign up
    company: "", // Required for userType = "hunter" sign up
    jobTitle: "", // Required for userType = "hunter" sign up
    profileActivated: true, // Default value = false after "talent" signs up
    profileCard: {
      // Default value = object with undefined values | will populate after "talent" created a profile card in My Profile page
      profileFirstName: "laura",
      profileLastName: "smith",
      profileJobTitle: "frontend developer",
      profileEmail: "laurasmith@fakegmail.com",
      profileLinkedIn: "fakelinkedin.com",
      profileWebsite: "laurasmith.io",
      profileSkills: ["front-end-development", "web-design"],
      profileBio:
        "Communicator. Reader. Movie fanatic. Travel buff. Gamer. Zombie practitioner. Social media fan. Total pop culture junkie. Coffee scholar.",
      profileExperience: 6,
      profileImage: "laura.png",
    },
    connections: [
      9, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 3, // nanoid() - programatically generated throu NanoID library
    email: "jameswillems@fakegmail.com", //check for valid email | required for both hunter and talent | Check if user already exists <-> later feature
    password: "1234", //check for valid email | required for both hunter and talent
    userType: "talent", // Radio button? | Required | either "hunter" or "talent"
    firstName: "", // Required for userType = "hunter" sign up
    lastName: "", // Required for userType = "hunter" sign up

    company: "", // Required for userType = "hunter" sign up
    jobTitle: "", // Required for userType = "hunter" sign up
    profileActivated: true, // Default value = false after "talent" signs up
    profileCard: {
      // Default value = object with undefined values | will populate after "talent" created a profile card in My Profile page
      profileFirstName: "james",
      profileLastName: "willems",

      profileJobTitle: "video editor",
      profileEmail: "james@fakegmail.com",
      profileLinkedIn: "fakelinkedin.com",
      profileWebsite: "jameswillems.io",
      profileSkills: ["videography"],
      profileBio:
        "Bacon maven. Devoted coffee ninja. Travel lover. Alcohol fan. Beer trailblazer. Introvert.",
      profileExperience: 3,
      profileImage: "james.png",
    },
    connections: [
      9, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 4, // nanoid() - programatically generated throu NanoID library
    email: "adam@fakegmail.com", //check for valid email | required for both hunter and talent | Check if user already exists <-> later feature
    password: "1234", //check for valid email | required for both hunter and talent
    userType: "talent", // Radio button? | Required | either "hunter" or "talent"
    firstName: "", // Required for userType = "hunter" sign up
    lastName: "", // Required for userType = "hunter" sign up
    company: "", // Required for userType = "hunter" sign up
    jobTitle: "", // Required for userType = "hunter" sign up
    profileActivated: true, // Default value = false after "talent" signs up
    profileCard: {
      // Default value = object with undefined values | will populate after "talent" created a profile card in My Profile page
      profileFirstName: "adam",
      profileLastName: "kovic",
      profileJobTitle: "backend developer",
      profileEmail: "adam@fakegmail.com",
      profileLinkedIn: "fakelinkedin.com",
      profileWebsite: "adamkovic.io",
      profileSkills: ["back-end-development", "android-development"],
      profileBio:
        "Reader. Creator. Beer enthusiast. Problem solver. Music ninja. Communicator. Food junkie.",
      profileExperience: 2,
      profileImage: "adam.png",
    },
    connections: [],
  },
  {
    id: 5, // nanoid() - programatically generated throu NanoID library
    email: "bruce@fakegmail.com", //check for valid email | required for both hunter and talent | Check if user already exists <-> later feature
    password: "1234", //check for valid email | required for both hunter and talent
    userType: "talent", // Radio button? | Required | either "hunter" or "talent"
    firstName: "", // Required for userType = "hunter" sign up
    lastName: "", // Required for userType = "hunter" sign up

    company: "", // Required for userType = "hunter" sign up
    jobTitle: "", // Required for userType = "hunter" sign up
    profileActivated: true, // Default value = false after "talent" signs up
    profileCard: {
      // Default value = object with undefined values | will populate after "talent" created a profile card in My Profile page
      profileFirstName: "bruce",
      profileLastName: "greene",
      profileJobTitle: "software developer",
      profileEmail: "bruce@fakegmail.com",
      profileLinkedIn: "fakelinkedin.com",
      profileWebsite: "brucegreene.io",
      profileSkills: ["web-design", "software-engineering"],
      profileBio:
        "Zombie nerd. Friendly beer lover. Coffee specialist. Introvert. Falls down a lot.",
      profileExperience: 8,
      profileImage: "bruce.png",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 6, // nanoid() - programatically generated throu NanoID library
    email: "elysewillems@fakegmail.com", //check for valid email | required for both hunter and talent | Check if user already exists <-> later feature
    password: "1234", //check for valid email | required for both hunter and talent
    userType: "talent", // Radio button? | Required | either "hunter" or "talent"
    firstName: "", // Required for userType = "hunter" sign up
    lastName: "", // Required for userType = "hunter" sign up

    company: "", // Required for userType = "hunter" sign up
    jobTitle: "", // Required for userType = "hunter" sign up
    profileActivated: true, // Default value = false after "talent" signs up
    profileCard: {
      // Default value = object with undefined values | will populate after "talent" created a profile card in My Profile page
      profileFirstName: "elyse",
      profileLastName: "willems",
      profileJobTitle: "Web Designer",
      profileEmail: "elyse@fakegmail.com",
      profileLinkedIn: "fakelinkedin.com",
      profileWebsite: "elysewillems.io",
      profileSkills: ["web-design"],
      profileBio:
        "Social media fanatic. Bacon practitioner. Zombieaholic. Wannabe music nerd. Coffee evangelist.",
      profileExperience: 3,
      profileImage: "elyse.png",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 7, // nanoid() - programatically generated throu NanoID library
    email: "lawrence@fakegmail.com", //check for valid email | required for both hunter and talent | Check if user already exists <-> later feature
    password: "1234", //check for valid email | required for both hunter and talent
    userType: "talent", // Radio button? | Required | either "hunter" or "talent"
    firstName: "", // Required for userType = "hunter" sign up
    lastName: "", // Required for userType = "hunter" sign up

    company: "", // Required for userType = "hunter" sign up
    jobTitle: "", // Required for userType = "hunter" sign up
    profileActivated: true, // Default value = false after "talent" signs up
    profileCard: {
      // Default value = object with undefined values | will populate after "talent" created a profile card in My Profile page
      profileFirstName: "lawrence",
      profileLastName: "sonntag",

      profileJobTitle: "front end developer",
      profileEmail: "lawrence@fakegmail.com",
      profileLinkedIn: "fakelinkedin.com",
      profileWebsite: "lawrencesonntag.io",
      profileSkills: ["front-end-development", "web-design"],
      profileBio:
        "Entrepreneur. Infuriatingly humble problem solver. Lifelong zombie geek. Alcohol buff. Wannabe bacon guru.",
      profileExperience: 6,
      profileImage: "lawrence.png",
    },
    connections: [],
  },
  {
    id: 8, // nanoid() - programatically generated throu NanoID library
    email: "alanahpearce@fakegmail.com", //check for valid email | required for both hunter and talent | Check if user already exists <-> later feature
    password: "1234", //check for valid email | required for both hunter and talent
    userType: "talent", // Radio button? | Required | either "hunter" or "talent"
    firstName: "", // Required for userType = "hunter" sign up
    lastName: "", // Required for userType = "hunter" sign up

    company: "", // Required for userType = "hunter" sign up
    jobTitle: "", // Required for userType = "hunter" sign up
    profileActivated: true, // Default value = false after "talent" signs up
    profileCard: {
      // Default value = object with undefined values | will populate after "talent" created a profile card in My Profile page
      profileFirstName: "alanah",
      profileLastName: "pearce",

      profileJobTitle: "graphic designer",
      profileEmail: "alanahpearce@fakegmail.com",
      profileLinkedIn: "fakelinkedin.com",
      profileWebsite: "alanahpearce.io",
      profileSkills: ["graphic-design"],
      profileBio:
        "Music aficionado. Social media specialist. Writer. Reader. Creator. Hipster-friendly analyst.",
      profileExperience: 6,
      profileImage: "alanah.png",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 9, // nanoid() - programatically generated throu NanoID library
    email: "jamiefisher@outlook.com", //check for valid email | required for both hunter and talent | Check if user already exists <-> later feature
    password: "12341234", //check for valid email | required for both hunter and talent | 8 - 20 characters?
    userType: "hunter", // Radio button? | Required | either "hunter" or "talent"
    firstName: "jamie", // Required for userType = "hunter" sign up
    lastName: "fisher", // Required for userType = "hunter" sign up

    company: "Lymann Tech", // Required for userType = "hunter" sign up
    jobTitle: "Lead Recruiter", // Required for userType = "hunter" sign up
    profileActivated: false, // Default value = false after "talent" signs up
    profileCard: {
      // Default value = object with undefined values | will populate after "talent" created a profile card in My Profile page
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "", //30 - 50 words?
      profileExperience: "",
    },
    connections: [1, 3],
  },
  {
    id: 10,
    email: "liamsmith@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "liam",
      profileLastName: "smith",
      profileJobTitle: "front end developer",
      profileEmail: "liamsmith@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "liamsmith.io",
      profileSkills: ["front-end-development", "web-design"],
      profileBio:
        "Incurable zombie lover. Food maven. Tv aficionado. Pop culture practitioner. Passionate travel fanatic. Bacon geek. Unable to type with boxing gloves on.",
      profileExperience: 6,
      profileImage: "liamsmith.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 11,
    email: "noahjohnson@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "noah",
      profileLastName: "johnson",
      profileJobTitle: "photographer",
      profileEmail: "noahjohnson@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "noahjohnson.io",
      profileSkills: ["photography", "graphic-design"],
      profileBio:
        "Twitter fanatic. Troublemaker. Subtly charming music aficionado. Travel lover. Problem solver. Incurable reader. Professional gamer.",
      profileExperience: 4,
      profileImage: "noahjohnson.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 12,
    email: "emmawilliams@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "emma",
      profileLastName: "williams",
      profileJobTitle: "software engineer",
      profileEmail: "emmawilliams@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "emmawilliams.com",
      profileSkills: ["software-engineering"],
      profileBio:
        "Internet enthusiast. Twitter aficionado. Alcohol scholar. Travel evangelist. Friendly coffee nerd.",
      profileExperience: 8,
      profileImage: "emmawilliams.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 13,
    email: "oliverbrown@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "oliver",
      profileLastName: "brown",
      profileJobTitle: "animator",
      profileEmail: "oliverbrown@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "oliverbrown.net",
      profileSkills: ["digital-animation"],
      profileBio:
        "Extreme food enthusiast. Entrepreneur. Friendly music fanatic. Coffee evangelist. Alcohol geek.",
      profileExperience: 4,
      profileImage: "oliverbrown.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 14,
    email: "charlottejones@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "charlotte",
      profileLastName: "jones",
      profileJobTitle: "web designer",
      profileEmail: "charlottejones@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "charlottejones.co",
      profileSkills: ["web-design", "graphic-design"],
      profileBio:
        "Travel evangelist. Twitter junkie. Internet geek. Pop culture scholar. Evil tv aficionado. Web buff.",
      profileExperience: 3,
      profileImage: "charlottejones.jpg",
    },
    connections: [],
  },
  {
    id: 15,
    email: "ameliagarcia@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "amelia",
      profileLastName: "garcia",
      profileJobTitle: "software developer",
      profileEmail: "ameliagarcia@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "ameliagarcia.com",
      profileSkills: ["front-end-development", "web-design"],
      profileBio:
        "Future teen idol. Communicator. Internetaholic. Web aficionado. Gamer. Incurable food scholar. Evil pop culture junkie. Bacon guru.",
      profileExperience: 2,
      profileImage: "ameliagarcia.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 16,
    email: "elijahmiller@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "elijah",
      profileLastName: "miller",
      profileJobTitle: "front end developer",
      profileEmail: "elijahmiller@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "elijahmiller.org",
      profileSkills: ["front-end-development"],
      profileBio:
        "Alcohol lover. Amateur thinker. Organizer. Passionate troublemaker. Travel buff. Reader. Coffee specialist. Tv fan.",
      profileExperience: 2,
      profileImage: "elijahmiller.jpg",
    },
    connections: [],
  },
  {
    id: 17,
    email: "jamesdavis@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "james",
      profileLastName: "davis",
      profileJobTitle: "photographer",
      profileEmail: "jamesdavis@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "jamesdavis.io",
      profileSkills: ["photography", "graphic-design"],
      profileBio:
        "Hipster-friendly alcohol advocate. Beer specialist. Proud analyst. Tv expert.",
      profileExperience: 5,
      profileImage: "jamesdavis.jpg",
    },
    connections: [],
  },
  {
    id: 18,
    email: "avarodriguez@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "ava",
      profileLastName: "rodriguez",
      profileJobTitle: "software engineer",
      profileEmail: "avarodriguez@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "avarodriguez.io",
      profileSkills: ["software-engineering"],
      profileBio:
        "Award-winning tv aficionado. Proud twitter ninja. Social media lover. Avid food evangelist. Amateur gamer. Entrepreneur.",
      profileExperience: 9,
      profileImage: "avarodriguez.jpg",
    },
    connections: [],
  },
  {
    id: 19,
    email: "williammartinez@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "william",
      profileLastName: "martinez",
      profileJobTitle: "animator",
      profileEmail: "williammartinez@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "williammartinez.net",
      profileSkills: ["digital-animation"],
      profileBio:
        "Web scholar. Coffee evangelist. Incurable creator. Food enthusiast. Friendly explorer. Organizer.",
      profileExperience: 12,
      profileImage: "williammartinez.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 20,
    email: "sophiahernandez@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "sophia",
      profileLastName: "hernandez",
      profileJobTitle: "web designer",
      profileEmail: "sophiahernandez@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "sophiahernandez.co",
      profileSkills: ["web-design", "graphic-design"],
      profileBio:
        "Zombie guru. Twitteraholic. Alcohol scholar. Social media trailblazer. Travel aficionado.",
      profileExperience: 1,
      profileImage: "sophiahernandez.jpg",
    },
    connections: [],
  },
  {
    id: 21,
    email: "isabellalopez@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "isabella",
      profileLastName: "lopez",
      profileJobTitle: "graphic designer",
      profileEmail: "isabellalopez@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "isabellalopez.com",
      profileSkills: ["web-design", "graphic-design"],
      profileBio:
        "Travel geek. Entrepreneur. Beer maven. Music fanatic. Alcohol expert. Zombie junkie. Food nerd. Pop culture ninja.",
      profileExperience: 0,
      profileImage: "isabellalopez.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 22,
    email: "benjamingonzalez@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "benjamin",
      profileLastName: "gonzalez",
      profileJobTitle: "mobile app developer",
      profileEmail: "benjamingonzalez@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "benjamingonzalez.org",
      profileSkills: ["ios-development", "android-development"],
      profileBio:
        "Music maven. Pop culture lover. Alcohol aficionado. Zombie practitioner. Lifelong analyst. Food fanatic. Coffee junkie.",
      profileExperience: 7,
      profileImage: "benjamingonzalez.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 23,
    email: "lucaswilson@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "lucas",
      profileLastName: "wilson",
      profileJobTitle: "android developer",
      profileEmail: "lucaswilson@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "lucaswilson.io",
      profileSkills: ["android-development"],
      profileBio:
        "Zombie expert. Internet trailblazer. Bacon fanatic. Travelaholic. Award-winning music advocate. Hardcore explorer.",
      profileExperience: 3,
      profileImage: "lucaswilson.jpg",
    },
    connections: [],
  },
  {
    id: 24,
    email: "miaanderson@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "mia",
      profileLastName: "anderson",
      profileJobTitle: "back end developer",
      profileEmail: "miaanderson@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "miaanderson.io",
      profileSkills: ["back-end-development"],
      profileBio:
        "Student. Amateur internet guru. Social media geek. Professional bacon maven.",
      profileExperience: 2,
      profileImage: "miaanderson.jpg",
    },
    connections: [],
  },
  {
    id: 25,
    email: "henrythomas@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "henry",
      profileLastName: "thomas",
      profileJobTitle: "software engineer",
      profileEmail: "henrythomas@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "henrythomas.io",
      profileSkills: ["software-engineering"],
      profileBio:
        "Internet practitioner. Passionate pop culture fanatic. Incurable zombie expert. Twitter nerd. Musicaholic.",
      profileExperience: 4,
      profileImage: "henrythomas.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 26,
    email: "evelyntaylor@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "evelyn",
      profileLastName: "taylor",
      profileJobTitle: "animator",
      profileEmail: "evelyntaylor@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "evelyntaylor.io",
      profileSkills: ["digital-animation", "graphic-design"],
      profileBio:
        "Coffee aficionado. Gamer. Tv ninja. Incurable introvert. Communicator. Twitteraholic. Beer nerd.",
      profileExperience: 2,
      profileImage: "evelyntaylor.jpg",
    },
    connections: [],
  },
  {
    id: 27,
    email: "harpermoore@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "harper",
      profileLastName: "moore",
      profileJobTitle: "web designer",
      profileEmail: "harpermoore@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "harpermoore.com",
      profileSkills: ["web-design"],
      profileBio:
        "Music nerd. Hardcore tv junkie. Freelance internet aficionado. Typical alcohol practitioner. Amateur student. Food maven. Coffee enthusiast.",
      profileExperience: 2,
      profileImage: "harpermoore.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 28,
    email: "theodorejackson@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "theodore",
      profileLastName: "jackson",
      profileJobTitle: "graphic designer",
      profileEmail: "theodorejackson@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "theodorejackson.net",
      profileSkills: ["digital-animation", "graphic-design"],
      profileBio:
        "Award-winning bacon practitioner. Hardcore communicator. Tv buff. Alcohol geek. Web specialist. Total creator. Unapologetic beer evangelist.",
      profileExperience: 1,
      profileImage: "theodorejackson.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 29,
    email: "jackmartin@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "jack",
      profileLastName: "martin",
      profileJobTitle: "mobile app developer",
      profileEmail: "jackmartin@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "jackmartin.co",
      profileSkills: ["ios-development", "android-development"],
      profileBio:
        "Web scholar. Introvert. Explorer. Social media fanatic. Twitter specialist. Writer. Thinker. Beer geek. Coffee buff.",
      profileExperience: 6,
      profileImage: "jackmartin.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 30,
    email: "lunalee@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "luna",
      profileLastName: "lee",
      profileJobTitle: "front end developer",
      profileEmail: "lunalee@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "lunalee.io",
      profileSkills: ["front-end-development", "web-design"],
      profileBio:
        "Lifelong pop culture evangelist. Twitter practitioner. Total food specialist. Communicator. Musicaholic. Bacon nerd.",
      profileExperience: 4,
      profileImage: "lunalee.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 31,
    email: "leviperez@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "levi",
      profileLastName: "perez",
      profileJobTitle: "photographer",
      profileEmail: "leviperez@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "leviperez.io",
      profileSkills: ["photography", "graphic-design"],
      profileBio:
        "Coffee guru. Friend of animals everywhere. Prone to fits of apathy. Twitter geek. Tv advocate. Reader. Beer aficionado.",
      profileExperience: 8,
      profileImage: "leviperez.jpg",
    },
    connections: [],
  },
  {
    id: 32,
    email: "camilathompson@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "camila",
      profileLastName: "thompson",
      profileJobTitle: "software engineer",
      profileEmail: "camilathompson@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "camilathompson.com",
      profileSkills: ["software-engineering"],
      profileBio:
        "Zombie scholar. Certified pop cultureaholic. Bacon geek. Music practitioner. Travel buff. Twitter nerd. Entrepreneur. Beer maven. Typical communicator.",
      profileExperience: 9,
      profileImage: "camilathompson.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 33,
    email: "giannawhite@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "gianna",
      profileLastName: "white",
      profileJobTitle: "animator",
      profileEmail: "giannawhite@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "giannawhite.net",
      profileSkills: ["digital-animation", "graphic-design"],
      profileBio:
        "Beer enthusiast. Social media fanatic. Gamer. Tv buff. Internet advocate. Twitter scholar. Web fan. Troublemaker. Food geek. Bacon junkie.",
      profileExperience: 12,
      profileImage: "giannawhite.jpg",
    },
    connections: [],
  },
  {
    id: 34,
    email: "alexanderharris@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "alexander",
      profileLastName: "harris",
      profileJobTitle: "videographer",
      profileEmail: "alexanderharris@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "alexanderharris.co",
      profileSkills: ["videography", "photography"],
      profileBio:
        "Typical entrepreneur. Friendly bacon geek. Web nerd. Beer fanatic. Pop culture enthusiast.",
      profileExperience: 1,
      profileImage: "alexanderharris.jpg",
    },
    connections: [],
  },
  {
    id: 35,
    email: "jacksonsanchez@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "jackson",
      profileLastName: "sanchez",
      profileJobTitle: "graphic designer",
      profileEmail: "jacksonsanchez@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "jacksonsanchez.com",
      profileSkills: ["digital-animation", "graphic-design"],
      profileBio:
        "Tv enthusiast. Reader. Twitter advocate. Web specialist. Subtly charming coffeeaholic. Internet fanatic. Bacon buff.",
      profileExperience: 0,
      profileImage: "jacksonsanchez.jpg",
    },
    connections: [],
  },
  {
    id: 36,
    email: "elizabethclark@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "elizabeth",
      profileLastName: "clark",
      profileJobTitle: "mobile app developer",
      profileEmail: "elizabethclark@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "elizabethclark.org",
      profileSkills: ["ios-development", "android-development"],
      profileBio:
        "Pop culture evangelist. Alcohol fanatic. Analyst. Typical bacon lover. Food aficionado. Tv scholar.",
      profileExperience: 7,
      profileImage: "elizabethclark.jpg",
    },
    connections: [],
  },
  {
    id: 37,
    email: "mateoramirez@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "mateo",
      profileLastName: "ramirez",
      profileJobTitle: "web developer",
      profileEmail: "mateoramirez@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "mateoramirez.io",
      profileSkills: ["back-end-development", "web-design"],
      profileBio:
        "Evil coffee practitioner. Beer scholar. Bacon fanatic. Introvert. Amateur web specialist. Travel fan. Passionate gamer. Tv enthusiast.",
      profileExperience: 3,
      profileImage: "mateoramirez.jpg",
    },
    connections: [],
  },
  {
    id: 38,
    email: "eleanorlewis@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "eleanor",
      profileLastName: "lewis",
      profileJobTitle: "front end developer",
      profileEmail: "eleanorlewis@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "eleanorlewis.io",
      profileSkills: ["front-end-development"],
      profileBio:
        "Bacon maven. Social media aficionado. Award-winning analyst. Troublemaker. Incurable beer trailblazer. Passionate pop culture practitioner. Amateur travel buff.",
      profileExperience: 2,
      profileImage: "eleanorlewis.jpg",
    },
    connections: [],
  },
  {
    id: 39,
    email: "ellarobinson@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "ella",
      profileLastName: "robinson",
      profileJobTitle: "videographer",
      profileEmail: "ellarobinson@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "ellarobinson.net",
      profileSkills: ["videography", "photography"],
      profileBio:
        "Twitter expert. Travel ninja. Student. Subtly charming pop culture geek. Hipster-friendly tv lover. Avid introvert.",
      profileExperience: 4,
      profileImage: "ellarobinson.jpg",
    },
    connections: [],
  },
  {
    id: 40,
    email: "danielwalker@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "daniel",
      profileLastName: "walker",
      profileJobTitle: "software engineer",
      profileEmail: "danielwalker@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "danielwalker.co",
      profileSkills: ["software-engineering"],
      profileBio:
        "Avid zombie nerd. Evil pop culture specialist. Music expert. General food scholar. Incurable tv trailblazer. Explorer. Prone to fits of apathy.",
      profileExperience: 2,
      profileImage: "danielwalker.jpg",
    },
    connections: [],
  },
  {
    id: 41,
    email: "michaelyoung@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "michael",
      profileLastName: "young",
      profileJobTitle: "photographer",
      profileEmail: "michaelyoung@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "michaelyoung.com",
      profileSkills: ["photography", "graphic-design"],
      profileBio:
        "Reader. Freelance travel enthusiast. Coffee fanatic. Troublemaker. Bacon ninja. Explorer.",
      profileExperience: 2,
      profileImage: "michaelyoung.jpg",
    },
    connections: [],
  },
  {
    id: 42,
    email: "abigailallen@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "abigail",
      profileLastName: "allen",
      profileJobTitle: "web designer",
      profileEmail: "abigailallen@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "abigailallen.org",
      profileSkills: ["web-design", "graphic-design"],
      profileBio:
        "Bacon scholar. Subtly charming social media aficionado. Zombie geek. Beeraholic. Alcohol buff.",
      profileExperience: 1,
      profileImage: "abigailallen.jpg",
    },
    connections: [],
  },
  {
    id: 43,
    email: "masonking@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "mason",
      profileLastName: "king",
      profileJobTitle: "graphic designer",
      profileEmail: "masonking@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "masonking.io",
      profileSkills: ["digital-animation", "graphic-design"],
      profileBio:
        "Thinker. Internet guru. Wannabe communicator. Falls down a lot. Music geek. Friendly organizer.",
      profileExperience: 2,
      profileImage: "masonking.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 44,
    email: "sofiawright@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "sofia",
      profileLastName: "wright",
      profileJobTitle: "mobile app developer",
      profileEmail: "sofiawright@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "sofiawright.io",
      profileSkills: ["ios-development", "android-development"],
      profileBio:
        "Travel ninja. Internet advocate. Future teen idol. Bacon fanatic. Amateur twitter maven.",
      profileExperience: 4,
      profileImage: "sofiawright.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 45,
    email: "averyscott@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "avery",
      profileLastName: "scott",
      profileJobTitle: "web developer",
      profileEmail: "averyscott@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "averyscott.io",
      profileSkills: ["back-end-development"],
      profileBio:
        "Organizer. Communicator. Writer. Coffee aficionado. Troublemaker. Devoted alcohol scholar. Internet evangelist.",
      profileExperience: 2,
      profileImage: "averyscott.jpg",
    },
    connections: [],
  },
  {
    id: 46,
    email: "sebastiantorres@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "sebastian",
      profileLastName: "torres",
      profileJobTitle: "back end developer",
      profileEmail: "sebastiantorres@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "sebastiantorres.io",
      profileSkills: ["back-end-development"],
      profileBio:
        "Alcohol ninja. Subtly charming food junkie. Bacon advocate. Coffee aficionado. Web trailblazer. Communicator. Twitter fan. Award-winning internet fanatic.",
      profileExperience: 2,
      profileImage: "sebastiantorres.jpg",
    },
    connections: [],
  },
  {
    id: 47,
    email: "ethannguyen@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "ethan",
      profileLastName: "nguyen",
      profileJobTitle: "software engineer",
      profileEmail: "ethannguyen@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "ethannguyen.com",
      profileSkills: ["software-engineering"],
      profileBio:
        "Communicator. Bacon buff. Lifelong tv fanatic. Twitter enthusiast. Coffee geek. Freelance beeraholic. Zombie practitioner.",
      profileExperience: 1,
      profileImage: "ethannguyen.jpg",
    },
    connections: [],
  },
  {
    id: 48,
    email: "scarletthill@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "scarlett",
      profileLastName: "hill",
      profileJobTitle: "animator",
      profileEmail: "scarletthill@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "scarletthill.net",
      profileSkills: ["digital-animation", "graphic-design"],
      profileBio:
        "Internet practitioner. Analyst. Problem solver. Food ninja. Tv junkie. Coffee guru. Thinker.",
      profileExperience: 9,
      profileImage: "scarletthill.jpg",
    },
    connections: [],
  },
  {
    id: 49,
    email: "loganflores@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "logan",
      profileLastName: "flores",
      profileJobTitle: "web designer",
      profileEmail: "loganflores@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "loganflores.co",
      profileSkills: ["web-design", "graphic-design"],
      profileBio:
        "Amateur social media trailblazer. Web scholar. Bacon specialist.",
      profileExperience: 12,
      profileImage: "loganflores.jpg",
    },
    connections: [],
  },
  {
    id: 50,
    email: "emilygreen@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "emily",
      profileLastName: "green",
      profileJobTitle: "graphic designer",
      profileEmail: "emilygreen@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "emilygreen.com",
      profileSkills: ["digital-animation", "graphic-design"],
      profileBio:
        "Twitter practitioner. Avid tv maven. Falls down a lot. Troublemaker. General communicator.",
      profileExperience: 1,
      profileImage: "emilygreen.jpg",
    },
    connections: [],
  },
  {
    id: 51,
    email: "ariaadams@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "aria",
      profileLastName: "adams",
      profileJobTitle: "mobile app developer",
      profileEmail: "ariaadams@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "ariaadams.org",
      profileSkills: ["ios-development", "android-development"],
      profileBio:
        "Proud communicator. Devoted analyst. Thinker. Avid twitter fan. Entrepreneur. Troublemaker. Certified reader.",
      profileExperience: 0,
      profileImage: "ariaadams.jpg",
    },
    connections: [],
  },
  {
    id: 52,
    email: "owennelson@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "owen",
      profileLastName: "nelson",
      profileJobTitle: "front end developer",
      profileEmail: "owennelson@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "owennelson.io",
      profileSkills: ["front-end-development", "web-design"],
      profileBio:
        "Internet geek. Troublemaker. Food nerd. Web guru. Beer enthusiast. Reader. Certified coffee practitioner.",
      profileExperience: 7,
      profileImage: "owennelson.jpg",
    },
    connections: [],
  },
  {
    id: 53,
    email: "samuelbaker@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "samuel",
      profileLastName: "baker",
      profileJobTitle: "videographer",
      profileEmail: "samuelbaker@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "samuelbaker.io",
      profileSkills: ["videography", "photography"],
      profileBio:
        "General student. Zombie fanatic. Travel expert. Total music guru. Bacon enthusiast. Pop culture specialist. Beer fan. Food evangelist.",
      profileExperience: 3,
      profileImage: "samuelbaker.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 54,
    email: "penelopehall@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "penelope",
      profileLastName: "hall",
      profileJobTitle: "photographer",
      profileEmail: "penelopehall@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "penelopehall.io",
      profileSkills: ["photography", "graphic-design"],
      profileBio:
        "Hipster-friendly explorer. Music fan. Freelance gamer. Extreme web scholar. Travel guru.",
      profileExperience: 2,
      profileImage: "penelopehall.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 55,
    email: "jacobrivera@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "jacob",
      profileLastName: "rivera",
      profileJobTitle: "animator",
      profileEmail: "jacobrivera@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "jacobrivera.io",
      profileSkills: ["digital-animation", "graphic-design"],
      profileBio:
        "Reader. Bacon fanatic. Writer. Twitter trailblazer. Web enthusiast. Organizer. Social media junkie.",
      profileExperience: 4,
      profileImage: "jacobrivera.jpg",
    },
    connections: [],
  },
  {
    id: 56,
    email: "chloecampbell@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "chloe",
      profileLastName: "campbell",
      profileJobTitle: "web designer",
      profileEmail: "chloecampbell@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "chloecampbell.com",
      profileSkills: ["web-design", "graphic-design"],
      profileBio:
        "Beer nerd. Certified organizer. Communicator. Introvert. Coffee guru. Zombie geek. Food junkie. Social media fan.",
      profileExperience: 2,
      profileImage: "chloecampbell.jpg",
    },
    connections: [],
  },
  {
    id: 57,
    email: "laylamitchell@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "layla",
      profileLastName: "mitchell",
      profileJobTitle: "graphic designer",
      profileEmail: "laylamitchell@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "laylamitchell.net",
      profileSkills: ["web-design", "graphic-design"],
      profileBio:
        "Evil beer maven. Tv nerd. Explorer. Subtly charming social media fanatic. Zombie geek.",
      profileExperience: 2,
      profileImage: "laylamitchell.jpg",
    },
    connections: [],
  },
  {
    id: 58,
    email: "ashercarter@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "asher",
      profileLastName: "carter",
      profileJobTitle: "mobile app developer",
      profileEmail: "ashercarter@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "ashercarter.co",
      profileSkills: ["ios-development", "android-development"],
      profileBio:
        "Travel trailblazer. Social media buff. Total explorer. Music maven.",
      profileExperience: 1,
      profileImage: "ashercarter.jpg",
    },
    connections: [],
  },
  {
    id: 59,
    email: "milaroberts@fakegmail.com",
    password: "1234",
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "mila",
      profileLastName: "roberts",
      profileJobTitle: "back end developer",
      profileEmail: "milaroberts@fakegmail.com",
      profileLinkedIn: "/samplelinkedin",
      profileWebsite: "milaroberts.io",
      profileSkills: ["back-end-development"],
      profileBio:
        "Zombie evangelist. Coffee buff. Reader. Beer aficionado. Devoted music advocate. Food junkie. Friendly travel enthusiast. Social media nerd.",
      profileExperience: 0,
      profileImage: "milaroberts.jpg",
    },
    connections: [
      60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
      78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
  },
  {
    id: 60,
    email: "daisyharrison@gmail.com",
    password: "12341234",
    userType: "hunter",
    firstName: "daisy",
    lastName: "harrison",
    company: "Refresh Right",
    jobTitle: "CEO",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 61,
    email: "wesleyfernandez@gmail.com",
    password: "12341234",
    userType: "hunter",
    firstName: "wesley",
    lastName: "fernandez",
    company: "Lite Repairs",
    jobTitle: "Head of Recruitment",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 62,
    email: "luciamcdonald@yahoo.com",
    password: "12341234",
    userType: "hunter",
    firstName: "lucia",
    lastName: "mcdonald",
    company: "The Helping Hands",
    jobTitle: "HR Specialist",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 63,
    email: "ximenawoods@aol.com",
    password: "12341234",
    userType: "hunter",
    firstName: "ximena",
    lastName: "woods",
    company: "Sanguine Services",
    jobTitle: "Lead Recruiter",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 64,
    email: "jeremiahwashington@outlook.com",
    password: "12341234",
    userType: "hunter",
    firstName: "jeremiah",
    lastName: "washington",
    company: "Admire Artists",
    jobTitle: "CTO",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 65,
    email: "hunterkennedy@icloud.com",
    password: "12341234",
    userType: "hunter",
    firstName: "hunter",
    lastName: "kennedy",
    company: "221A Baker Street",
    jobTitle: "Chief Diversity Officer",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 66,
    email: "magnoliawells@icloud.com",
    password: "12341234",
    userType: "hunter",
    firstName: "magnolia",
    lastName: "wells",
    company: "Hook, Line, and Sinker",
    jobTitle: "Head of Recruitment",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 67,
    email: "summervargas@outlook.com",
    password: "12341234",
    userType: "hunter",
    firstName: "summer",
    lastName: "vargas",
    company: "Snared Services",
    jobTitle: "HR Specialist",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 68,
    email: "adalynhenry@icloud.com",
    password: "12341234",
    userType: "hunter",
    firstName: "adalyn",
    lastName: "henry",
    company: "Apples and Oranges",
    jobTitle: "Head of Recruitment",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 69,
    email: "leonardochen@yahoo.com",
    password: "12341234",
    userType: "hunter",
    firstName: "leonardo",
    lastName: "chen",
    company: "Scoot Over Services",
    jobTitle: "HR Specialist",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 70,
    email: "jordanfreeman@gmail.com",
    password: "12341234",
    userType: "hunter",
    firstName: "jordan",
    lastName: "freeman",
    company: "Don’t Break a Bill",
    jobTitle: "Chief Diversity Officer",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 71,
    email: "josewebb@gmail.com",
    password: "12341234",
    userType: "hunter",
    firstName: "jose",
    lastName: "webb",
    company: "Mystery Meats Co.",
    jobTitle: "Lead Recruiter",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 72,
    email: "bennetttucker@gmail.com",
    password: "12341234",
    userType: "hunter",
    firstName: "bennett",
    lastName: "tucker",
    company: "Table Your Needs",
    jobTitle: "CTO",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 73,
    email: "reeseguzman@yahoo.com",
    password: "12341234",
    userType: "hunter",
    firstName: "reese",
    lastName: "guzman",
    company: "The Green Thumb Guys",
    jobTitle: "Chief Diversity Officer",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 74,
    email: "emersynburns@aol.com",
    password: "12341234",
    userType: "hunter",
    firstName: "emersyn",
    lastName: "burns",
    company: "Tell Me About It",
    jobTitle: "Head of Recruitment",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 75,
    email: "siennacrawford@outlook.com",
    password: "12341234",
    userType: "hunter",
    firstName: "sienna",
    lastName: "crawford",
    company: "Spilling The Beans Inc.",
    jobTitle: "CEO",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 76,
    email: "silasolson@icloud.com",
    password: "12341234",
    userType: "hunter",
    firstName: "silas",
    lastName: "olson",
    company: "EtchSketch",
    jobTitle: "Chief Diversity Officer",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 77,
    email: "nicholassimpson@icloud.com",
    password: "12341234",
    userType: "hunter",
    firstName: "nicholas",
    lastName: "simpson",
    company: "Maxxx Energy",
    jobTitle: "Head of Recruitment",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 78,
    email: "daisyporter@outlook.com",
    password: "12341234",
    userType: "hunter",
    firstName: "daisy",
    lastName: "porter",
    company: "WeHeartShoes",
    jobTitle: "HR Specialist",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 79,
    email: "alinahunter@icloud.com",
    password: "12341234",
    userType: "hunter",
    firstName: "alina",
    lastName: "hunter",
    company: "Pop-Culture Partners",
    jobTitle: "Lead Recruiter",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 80,
    email: "luciagordon@outlook.com",
    password: "12341234",
    userType: "hunter",
    firstName: "lucia",
    lastName: "gordon",
    company: "Eco Focus",
    jobTitle: "CTO",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 81,
    email: "ximenamendez@icloud.com",
    password: "12341234",
    userType: "hunter",
    firstName: "ximena",
    lastName: "mendez",
    company: "Innovation Arch",
    jobTitle: "Chief Diversity Officer",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 82,
    email: "parkersilva@yahoo.com",
    password: "12341234",
    userType: "hunter",
    firstName: "parker",
    lastName: "silva",
    company: "Strat Security",
    jobTitle: "Head of Recruitment",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 83,
    email: "beaushaw@gmail.com",
    password: "12341234",
    userType: "hunter",
    firstName: "beau",
    lastName: "shaw",
    company: "Inspire Fitness Co",
    jobTitle: "HR Specialist",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 84,
    email: "westonsnyder@gmail.com",
    password: "12341234",
    userType: "hunter",
    firstName: "weston",
    lastName: "snyder",
    company: "Candor Corp",
    jobTitle: "Head of Recruitment",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 85,
    email: "magnoliamason@gmail.com",
    password: "12341234",
    userType: "hunter",
    firstName: "magnolia",
    lastName: "mason",
    company: "Cogent Data",
    jobTitle: "HR Specialist",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 86,
    email: "summerdixon@yahoo.com",
    password: "12341234",
    userType: "hunter",
    firstName: "summer",
    lastName: "dixon",
    company: "Epic Adventure Inc",
    jobTitle: "Chief Diversity Officer",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 87,
    email: "adalynmunoz@aol.com",
    password: "12341234",
    userType: "hunter",
    firstName: "adalyn",
    lastName: "munoz",
    company: "Sanguine Skincare",
    jobTitle: "Lead Recruiter",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 88,
    email: "sloanehunt@outlook.com",
    password: "12341234",
    userType: "hunter",
    firstName: "sloane",
    lastName: "hunt",
    company: "Vortex Solar",
    jobTitle: "CTO",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 89,
    email: "austinhicks@outlook.com",
    password: "12341234",
    userType: "hunter",
    firstName: "austin",
    lastName: "hicks",
    company: "Admire Arts",
    jobTitle: "Chief Diversity Officer",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 90,
    email: "connorholmes@icloud.com",
    password: "12341234",
    userType: "hunter",
    firstName: "connor",
    lastName: "holmes",
    company: "Bravura Inc",
    jobTitle: "Head of Recruitment",
    profileActivated: false,
    profileCard: {
      profileFirstName: "",
      profileLastName: "",
      profileJobTitle: "",
      profileEmail: "",
      profileLinkedIn: "",
      profileWebsite: "",
      profileSkills: [],
      profileBio: "",
      profileExperience: "",
    },
    connections: [
      1, 3, 5, 6, 8, 10, 11, 12, 13, 15, 19, 21, 22, 25, 27, 28, 29, 30, 32, 43,
      44, 53, 54, 59,
    ],
  },
  {
    id: 91,
    email: "argelmiralles25@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "argel",
      profileLastName: "miralles",
      profileJobTitle: "Software Developer",
      profileEmail: "argelmiralles25@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "argelmiralles.netlify.app",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Writer. Zombie fanatic. Troublemaker. Travel enthusiast. Evil beer lover. Problem solver. Web buff.",
      profileExperience: 0,
      profileImage: "argel-profile.jpg",
    },
    connections: [],
  },
  {
    id: 92,
    email: "leojomar01@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "leo jomar",
      profileLastName: "reyes",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "leojomar01@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "leojomar01.github.io/E-Portfolio",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Travel aficionado. Social media buff. Avid coffee trailblazer. Thinker. Pop culture lover. Explorer. Organizer. Typical beer junkie.",
      profileExperience: 0,
      profileImage: "leo.jpg",
    },
    connections: [],
  },
  {
    id: 93,
    email: "neoremos@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "neoremos",
      profileLastName: "jamorabon",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "neoremos@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "neoremos.github.io/e-portfolio/portfolio.html",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Incurable internet junkie. Web advocate. Twitter nerd. Explorer. Entrepreneur. Passionate introvert. Travel evangelist. Troublemaker. Zombie expert.",
      profileExperience: 0,
      profileImage: "neo.jpg",
    },
    connections: [],
  },
  {
    id: 94,
    email: "xchan824@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "christian paulo",
      profileLastName: "gomonit",
      profileJobTitle: "Professional Copypaster",
      profileEmail: "xchan824@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "xchan824.github.io/portfolio-v1",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Wannabe reader. Hipster-friendly organizer. Bacon expert. Devoted travel evangelist. Writer.",
      profileExperience: 0,
      profileImage: "christian.jpg",
    },
    connections: [],
  },
  {
    id: 95,
    email: "Jsscgtrrz26@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "jessica",
      profileLastName: "gutierrez",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "Jsscgtrrz26@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "my-portfolio-gy4dpoy7c-jessy-g26.vercel.app",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Organizer. Creator. Internet guru. Hipster-friendly explorer. Problem solver.",
      profileExperience: 0,
      profileImage: "jessica.jpg",
    },
    connections: [],
  },
  {
    id: 96,
    email: "spencerbohol3@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "spencer",
      profileLastName: "bohol",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "spencerbohol3@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "zxtm89j1.github.io/portfolio",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Travelaholic. Unable to type with boxing gloves on. Alcohol nerd. Tv geek. Amateur gamer. Pop culture scholar. Internet junkie. Organizer.",
      profileExperience: 0,
      profileImage: "spencer.jpg",
    },
    connections: [],
  },
  {
    id: 97,
    email: "adonisjr.suico@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "adonis jr",
      profileLastName: "suico",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "adonisjr.suico@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "adonisjr.github.io/myportfolio.github.io",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Beer specialist. Passionate thinker. Lifelong twitter evangelist. Social media guru. Troublemaker.",
      profileExperience: 0,
      profileImage: "adonis.jpg",
    },
    connections: [],
  },
  {
    id: 98,
    email: "jmtgalvez@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "miguel",
      profileLastName: "galvez",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "jmtgalvez@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "jmtgalvez.github.io",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Total beer scholar. Award-winning web fan. Zombie junkie. Food aficionado. Twitter practitioner.",
      profileExperience: 0,
      profileImage: "miguel.jpg",
    },
    connections: [],
  },
  {
    id: 99,
    email: "gianmigueltdc22@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "gian miguel",
      profileLastName: "dela cruz",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "gianmigueltdc22@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "gianmiguel.github.io/e-Portfolio",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Freelance beer specialist. Avid coffee nerd. Total gamer. Writer. Extreme problem solver. Unapologetic web fanatic.",
      profileExperience: 0,
      profileImage: "gianmiguel-profile.jpg",
    },
    connections: [],
  },
  {
    id: 100,
    email: "ibarra.erwin09@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "erwin",
      profileLastName: "ibarra",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "ibarra.erwin09@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "airwhen09.github.io/ErwinIbarra",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Travel geek. Pop culture fan. Alcohol junkie. Web maven. Student. Wannabe writer.",
      profileExperience: 0,
      profileImage: "erwin-profile.jpg",
    },
    connections: [],
  },
  {
    id: 101,
    email: "mnrichae@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "mary nikka richae",
      profileLastName: "abangan",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "mnrichae@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "mnrichae.github.io/portfolio",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Student. Food guru. Extreme coffee lover. Bacon scholar. Incurable gamer. Tv aficionado.",
      profileExperience: 0,
      profileImage: "richae.jpg",
    },
    connections: [],
  },
  {
    id: 102,
    email: "kensabella04@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "ken domenick",
      profileLastName: "sabella",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "kensabella04@gmail.com",
      profileLinkedIn: "www.linkedin.com/login",
      profileWebsite: "kdsabella.github.io/E-magazine.github.io",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Social media guru. Twitter fan. Friend of animals everywhere. Wannabe zombie buff.",
      profileExperience: 0,
      profileImage: "ken.jpg",
    },
    connections: [],
  },
  {
    id: 103,
    email: "paulpastor122297@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "paul maverick",
      profileLastName: "pastor",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "paulpastor122297@gmail.com",
      profileLinkedIn: "https://www.linkedin.com/login",
      profileWebsite: "paulmaverick.github.io/portfolio/",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Reader. Creator. Prone to fits of apathy. Coffee fanatic. Pop culture aficionado. Total beer enthusiast. Tv lover.",
      profileExperience: 0,
      profileImage: "paul.jpg",
    },
    connections: [],
  },
  {
    id: 104,
    email: "johangenuino@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "johan",
      profileLastName: "genuino",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "johangenuino@gmail.com",
      profileLinkedIn: "https://www.linkedin.com/login",
      profileWebsite: "hanjo24.github.io/Portfolio/",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Gamer. Hardcore analyst. Thinker. Certified introvert. Internet trailblazer. Incurable food geek. Twitter nerd.",
      profileExperience: 0,
      profileImage: "johan.jpg",
    },
    connections: [],
  },
  {
    id: 105,
    email: "nikegfernandez@gmail.com",
    password: '"12341234"',
    userType: "talent",
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    profileActivated: true,
    profileCard: {
      profileFirstName: "nike",
      profileLastName: "fernandez",
      profileJobTitle: "Full Stack Developer",
      profileEmail: "nikegfernandez@gmail.com",
      profileLinkedIn: "https://www.linkedin.com/login",
      profileWebsite: "nikegfernandez.github.io/naykportfolio.io/",
      profileSkills: ["full-stack-development"],
      profileBio:
        "Typical twitter fanatic. Entrepreneur. Beer maven. Alcoholaholic. Bacon fan. Student.",
      profileExperience: 0,
      profileImage: "nike.jpg",
    },
    connections: [],
  },
];

export default data;
